export type ChatExecutionStatus = 0 | 1 | 2 | 3 | 4 | 5 | 6

export const CHAT_EXECUTION_STATUS = {
  PENDING: 0 as const,
  RUNNING: 1 as const,
  COMPLETED: 2 as const,
  FAILED: 3 as const,
  CANCELLED: 4 as const,
  PAUSED: 5 as const,
  WAITING_INPUT: 6 as const,
}

export interface ChatExecution {
  id: string
  sessionId: string
  companyId: string
  userId: string
  status: ChatExecutionStatus
  errorMessage: string | null
  logs: Record<string, unknown>[]
  startedAt: string | null
  completedAt: string | null
  syncId: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}
